import TableModule from "components/Modules/Collections/TableModule"
import { getDataFromFirestoreCollection } from "helpers/Firestore"
import React from "react"

const CitySurveysTable = () => {
  return (
    <TableModule
      getData={async ({ firebaseUID }) => {
        return await getDataFromFirestoreCollection({
          sortBy: { key: "Name" },
          path: `City/Cities/DataBase/${firebaseUID}/Modules/56/DataBase`,
        })
      }}
      columns={[{ key: "Name", label: "Name" }]}
      searchKey={"Name"}
    />
  )
}

export default CitySurveysTable
